import React, { useState } from "react";
import { Container, Row, Col, Button, ButtonGroup } from "react-bootstrap";
import BudgetModeRulesCard from "../EditTeam/components/BudgetModeRulesCard";
import UCIPointsModal from "../EditTeam/components/UCIPointsModal";
import uciTeamPoints from "../../assets/uci_team_points.json";
import PickAndRankModeRulesCard from "../EditTeam/components/PickAndRankModeRulesCard";
import MultiplierModeRulesCard from "../EditTeam/components/MultiplierModeRulesCard";
import SeasonRulesCard from "../EditTeam/components/SeasonRulesCard";

const HowToPlay: React.FC = () => {
	// State to track which game mode is currently selected
	const [viewScoring, setViewScoring] = useState(false);
	const [activeMode, setActiveMode] = useState<
		"pickAndRank" | "budget" | "multiplier"
	>("budget");

	// Function to render the appropriate component based on active mode
	const renderGameModeContent = () => {
		switch (activeMode) {
			case "pickAndRank":
				return <PickAndRankModeRulesCard numberOfMen={4} numberOfWomen={2} />;
			case "budget":
				return (
					<BudgetModeRulesCard
						numberOfMen={4}
						numberOfWomen={2}
						budget={4000000}
						setViewScoring={() => setViewScoring(true)}
					/>
				);
			case "multiplier":
				return <MultiplierModeRulesCard numberOfMen={4} numberOfWomen={2} />;
			default:
				return (
					<BudgetModeRulesCard
						numberOfMen={4}
						numberOfWomen={2}
						budget={4000000}
						setViewScoring={() => setViewScoring(true)}
					/>
				);
		}
	};

	return (
		<Container className="how-to-play-container my-5">
			<Row className="text-white text-info mb-4">
				<Col>
					<h2 className="fs-1 fw-bold">How To Play</h2>
					<p>Learn the rules for our different game modes</p>
				</Col>
			</Row>

			<Row className="mb-4">
				<Col className="d-flex justify-content-center">
					<ButtonGroup>
						<Button
							variant={
								activeMode === "pickAndRank" ? "primary" : "outline-info"
							}
							onClick={() => setActiveMode("pickAndRank")}
						>
							Pick and Rank
						</Button>
						<Button
							variant={activeMode === "budget" ? "primary" : "outline-info"}
							onClick={() => setActiveMode("budget")}
						>
							Budget Mode
						</Button>
						<Button
							variant={activeMode === "multiplier" ? "primary" : "outline-info"}
							onClick={() => setActiveMode("multiplier")}
						>
							Multiplier Mode
						</Button>
					</ButtonGroup>
				</Col>
			</Row>

			<Row>
				<Col>
					<SeasonRulesCard />
				</Col>
			</Row>
			<Row>
				<Col>{renderGameModeContent()}</Col>
			</Row>
			<UCIPointsModal
				viewScoring={viewScoring}
				setViewScoring={setViewScoring}
				uciTeamPoints={uciTeamPoints}
			/>
		</Container>
	);
};

export default HowToPlay;
